// ===== rules/rule-0057-both-feet.ts =======================================
import { AdjustedLine, ModifierContext } from '../modifier-models';
import { BaseRule } from '../rule-base';

/**
 * 0057 – multiple procedures on *both feet*.
 * Algorithm (simplified):
 *   • find *all* tariff lines (non-modifier) preceding the 0057 line
 *     where `meta?.foot` equals 'second'        (caller-supplied flag)
 *   • multiply those lines by 0.75.
 *
 * If the caller doesn't tag feet we just warn.
 */
export class RuleBothFeet extends BaseRule {
    name = '0057 both-feet reduction 75 %';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        // Since we need to check if 0057 exists and find all second foot procedures,
        // we'll need to rely on the apply method for this rule
        if (autoApply) {
            line.trace.push('0057: Requires full context for calculation');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0057',
                message: 'Both-feet calculation requires full context',
                kind: 'overwrite'
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        const has0057 = lines.some(l => l.code === '0057');
        if (!has0057) return lines;

        const tagged = lines.filter(
            l => !l.isModifier && !l.isConsult && l.meta?.['foot'] === 'second'
        );

        if (!tagged.length) {
            warn.push(
                'Modifier 0057 present but no tariff lines flagged as meta.foot="second".'
            );
            return lines;
        }

        tagged.forEach(l => {
            l.adjustedUnits *= 0.75;
            l.trace.push('0057 x0.75');
        });
        return lines;
    }
}
